import { createContact, resetContact } from 'app/modules/contact/service';
import {
  getClaimsSubscriptionByNumber,
  getContractualDocument,
  getListImpayeInfo,
  getOffer,
  getSubscription,
  getSubscriptionAndOffer,
  resetUserInfo,
  updateUserInfo,
} from 'app/modules/contract/service/index';
import { IRootState } from 'app/shared/reducers';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  declarerSinistre,
  emptyRedirectLink,
  getClaimsByClient,
  getclaimsListBySubscriptionNumber,
  getclaimsListBySubscriptionNumberForContractDaitails,
} from 'app/modules/claim/service';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import {
  getContactEngineSelector,
  getContractStatusCms,
  getDesktopContractSelector,
  getModalInformationButton,
} from 'app/modules/cms/service/store/selectors';
import { getBankingInfo, getContractDetails, getContractState, getUserInfoSelector } from 'app/modules/contract/service/store/selectors';
import { checkBicAndIban } from 'app/modules/financial/service';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { View } from 'app/modules/rules/domain/View';
import { getDataView } from 'app/modules/rules/service/rulesService';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import ConfComp from 'app/shared/components/common/conf-component';
import ModalWithAction from 'app/shared/components/common/modal/modal-with-Action';
import ContractPageDetailSkeleton from 'app/shared/components/skeleton/desktop/s-contract-detail-page';
import { Constraint } from 'app/shared/util/constraint';

export const ContractDetailsPage = props => {
  const claims: any = useSelector<IRootState>(state => state.claim.claimListForContract);
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const redirectLink: any = useSelector<IRootState>(state => state.claim.redirectLink);
  const loading: any = useSelector<IRootState>(state => state.contract.loading);
  const loadingDocuement: any = useSelector<IRootState>(state => state.document.loading);
  const loadingCms: any = useSelector<IRootState>(state => state.cms.loading);
  const updated: any = useSelector<IRootState>(state => state.contract.updated);
  const rootSubscription: any = useSelector<IRootState>(state => state.contract.subscriptionModel.subscriptionSelected);
  const userInfo: any = useSelector<IRootState>(getUserInfoSelector);
  const contractDetail: any = useSelector<IRootState>(getContractDetails);
  const productOffre: any = useSelector<IRootState>(state => state.contract.subscriptionModel.productOffer);
  const viewDataitems = useSelector(getDataViewRules(View.CONTRACT_DETAIL_PAGE));
  const bankInfo: any = useSelector<IRootState>(getBankingInfo);
  const contractualInfo: any = useSelector<IRootState>(state => state.contract.subscriptionModel.ContractualDocuments);
  const contactForm: any = useSelector<IRootState>(state => state.contact.contactForm);
  const contactLoading: any = useSelector<IRootState>(state => state.contact.loading);
  const account: any = useSelector<IRootState>(state => state.authentication.account);
  const sellingPoint: any = useSelector<IRootState>(state => state.sellingPoint.connectedSellingPoint);
  const device: any = useSelector<IRootState>(state => state.global?.deviceType || '');
  const contractStatusCms: any = useSelector(getContractStatusCms);
  const contractCms: any = useSelector(getDesktopContractSelector);
  const contactCms: any = useSelector(getContactEngineSelector);
  const location: any = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [openModalUpdateInfo, setOpenModalUpdateInfo] = useState(false);
  const [updateUserModal, setUpdateUserModal] = useState(false);
  const [nbClaims, setNbClaims] = useState(0);
  const [contractRescind, setContractRescind] = useState(false);

  const contractState: any = useSelector<IRootState>(getContractState);
  const listImpaye: any = contractState?.listImpaye;
  const cmsModalInformation: any = useSelector(getModalInformationButton);

  const rulesContext: RulesContext = {
    key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
    entryDataRules: { view: View.CONTRACT_DETAIL_PAGE, productCode: rootSubscription?.productCode, deviceType: device },
  };
  const {
    match: { params },
  } = props;
  const dispatchor = useDispatch();
  const civility = rootSubscription?.subscriber?.title === 'MR';
  const [tabIndex, setTabIndex] = useState(0);
  const [query, setQuery] = useState(new URLSearchParams(location.search));
  const [menuValue, setMenuValue] = React.useState(0);
  const [successPay, setSuccessPay] = useState(false);
  const handleUpdateUserInfo = (data: any) => {
    dispatchor(updateUserInfo(data, ''));
  };
  const creatContact = contactInfo => dispatchor(createContact(contactInfo));
  const restContact = () => dispatchor(resetContact());
  const subsNumber = location.state?.subscription || params?.subNumber;

  const executerDeclarerSinistre = () => {
    dispatchor(declarerSinistre(rootSubscription?.number));
  };
  const handleDeclarer = () => {
    executerDeclarerSinistre();
  };
  const handleCheckBicAndIban = (value: any) => {
    const result: any = dispatchor(checkBicAndIban(value));
    return result;
  };

  useEffect(() => {
    if (redirectLink && redirectLink === 'error') {
      setOpenModal(true);
    } else {
      if (redirectLink != null) {
        window.location.href = redirectLink;
      }
    }
    dispatchor(emptyRedirectLink());
  }, [redirectLink]);

  useEffect(() => {
    loading === false && updated === true && setUpdateUserModal(true);
    setOpenModalUpdateInfo(true);
  }, [updated]);

  useEffect(() => {

    if (rootSubscription?.number && rootSubscription?.number !== '') {
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetOutstandingPayment')) {
        dispatchor(getListImpayeInfo(rootSubscription?.number));
      }
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetClaimListBySubscriptionNumber')) {
        dispatchor(getclaimsListBySubscriptionNumberForContractDaitails(rootSubscription?.number));
      }
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetOffer')) {
        dispatchor(getOffer((rootSubscription?.offerCodes || [])[0]));
      }

      if (viewDataitems?.dataRecoveryService?.find(service => service === 'getContractualDocument')) {
        dispatchor(getContractualDocument((rootSubscription?.offerCodes || [])[0]));
      }
    }
    if (
      viewDataitems?.dataRecoveryService?.find(service => service === 'DesktopContractTCostumerDet' || service === 'DesktopContractTPdvDet')
    ) {
      dispatchor(getDocCMS('desktop_contract_det_v2'));
    }
  }, [rootSubscription, viewDataitems]);

  useEffect(() => {
    dispatchor(getDataView(rulesContext));
    setNbClaims(location?.state?.nbClaims);
  }, [rootSubscription]);

  function getConstrante(constraint, confValue) {
    return Constraint(
      constraint,
      { accountState: account, sellingPointConnectedState: sellingPoint, subscriptionState: rootSubscription },
      confValue
    );
  }

  function setShowModalUserInfoUpdate(value?) {
    setOpenModalUpdateInfo(false);
    setUpdateUserModal(false);
  }

  useEffect(() => {
    const subscriptionNumber = subsNumber?.padStart(12, 0) || params?.subNumber?.padStart(12, 0);
    if (subscriptionNumber) {
      dispatchor(getSubscription(subscriptionNumber));
    }
    dispatchor(getDocCMS('desktop_contract_and_claim_status_v2'));
    dispatchor(resetUserInfo());
    setShowModalUserInfoUpdate();
  }, []);

  const handleChangeIndex = (index: number) => {
    if (index !== menuValue) {
      setMenuValue(index);
    }
  };

  return (
    <>
      {loadingCms || loading || loadingDocuement || contactLoading ? (
        <ContractPageDetailSkeleton />
      ) : (
        <div className="contract-detail-container pt-3">
          <div className="container-fluid px-0">
            <div className={'d-flex flex-wrap pt-3 w-100'}>
              <div className="row col-sm-12 col-lg-4  d-block mb-3">
                <div className="col-md-12 mb-3">
                  <ConfComp
                    code="USER_INFO_CONTRACT"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      rootSubscription,
                      data: userInfo,
                      updateUserInfo: handleUpdateUserInfo,
                      civility,
                      contractStatusCms,
                      contractCms,
                    }}
                  />
                </div>

                <div className="col-md-12 mb-3">
                  <ConfComp
                    code="ADRESSE_INFO"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      rootSubscription,
                      loading,
                      data: userInfo,
                      contractCms,
                      updateUserInfo: handleUpdateUserInfo,
                    }}
                  />
                </div>

                <div className="col-md-12">
                  <ConfComp
                    code="IBAN_INFO"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      rootSubscription,
                      data: bankInfo,
                      checkBicAndIban: handleCheckBicAndIban,
                      contractCms,
                    }}
                  />
                </div>
                <div className="col-md-12  mb-3">
                  <ConfComp
                    code="STATUS_BLOCK_INFO"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      data: { rootSubscription },
                      loading: false,
                      contractStatusCms,
                    }}
                  />
                </div>
                <div className="col-md-12  mb-3">
                  <ConfComp
                    code="ACTION_BLOCK_BUTTON"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      data: { rootSubscription, claims },
                      loading: false,
                      nbClaims: claims?.length || [],
                      router: location,
                      getClaims: getclaimsListBySubscriptionNumber,
                      getConstrante,
                    }}
                  />
                </div>
              </div>
              <div className="col-sm-12 col-lg-8">
                <div className="col-12 w-100 m-0 p-0">
                  <ConfComp
                    code="CLAIM_ACTION_WITH_STATUS_COMPONENT"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      data: { ...params, claims },
                      contract: contractDetail,
                      loading,
                      declarer: handleDeclarer,
                      getConstrante,
                    }}
                  />
                </div>
                {!contractRescind ? (
                  <div className={'col-12 p-0'}>
                    <ConfComp
                      code="CONTRACT_DETAILS_COMPONENT"
                      listCode={viewDataitems?.componentDataList}
                      props={{
                        loading,
                        claimContactCms: contactCms,
                        data: contractDetail,
                        subscription: rootSubscription,
                        productOffre,
                        contractualInfo,
                        avatar,
                        contactForm,
                        userInfo,
                        creatContact,
                        restContact,
                        contractCms,
                        contractRescind: setContractRescind,
                        listImpaye,
                        bankInfo,
                        handleCheckBicAndIban,
                        tabIndex,
                        setTabIndex,
                        successPay
                      }}
                    />
                  </div>
                ) : (
                  <div className={'col-12 p-0'}>
                    <ConfComp
                      code="DESKTOP_CHOICE_RESCIND"
                      listCode={viewDataitems?.componentDataList}
                      props={{
                        contractCms,
                        confData: viewDataitems?.componentDataList,
                        contractRescind: setContractRescind,
                      }}
                    />
                  </div>
                )}
                <div className={'col-12 p-0'}>
                  <ConfComp
                    code="DESKTOP_CONTRACT_RECAP"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      data: userInfo,
                      rootSubscription,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <ModalWithAction
            showModal={openModalUpdateInfo}
            setShowModel={setShowModalUserInfoUpdate}
            textBody={contractCms?.modal_succses_msg}
            icon={cmsModalInformation?.Success_Icon?.url}
            action={() => {
              setShowModalUserInfoUpdate(false);
            }}
            btnActionLabel={cmsModalInformation?.CLOSE_button}
          />

          <ModalWithAction
            showModal={contactForm}
            setShowModel={''}
            textBody={contractCms?.contact_tab?.contact_choice?.modal_messages?.modal_succes_message}
            icon={cmsModalInformation?.Success_Icon?.url}
            action={() => {
              restContact();
            }}
            btnActionLabel={cmsModalInformation?.CLOSE_button}
          />
          <ModalWithAction
            icon={cmsModalInformation?.erreur_Icon?.url}
            showModal={openModal}
            setShowModel={setOpenModal}
            textBody={"Suite à des conditions d'éligibilité, vous ne pouvez pas déclarer de sinistre."}
            action={() => {
              setOpenModal(false);
            }}
            btnActionLabel={cmsModalInformation?.CLOSE_button}
          />
        </div>
      )}
    </>
  );
};
